import React, {useCallback, useState} from 'react';
import CertificationForm from './CertificationForm';
import CertificationList from './CertificationList';
import {toast} from 'react-toastify';
import {COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES, getErrorUpdateToastPropsBy, getSuccesToastPropsBy} from '../../../../service/toastService';
import {createCurriculumVitaeCertification, deleteCurriculumVitaeCertification, updateCurriculumVitaeCertification} from '../../../../api/curriculumVitaeApi';
import { useDispatch } from "react-redux";
import { showModal } from "../../../../redux/system/actions";
import ConfirmModal from '../../../common/modals/ConfirmModal';

const CONFIRM_MODAL_ID = 'confirmModal';

function Certification({ curriculumVitae, setCurriculumVitae }) {
    const dispatch = useDispatch();
    const handleShowModal = useCallback((modalId) => dispatch(showModal(modalId)), [dispatch])

    const [certifications, setCertifications] = useState(curriculumVitae.curriculumVitaeCertifications || []);
    const [editingCertification, setEditingCertification] = useState(null);
    const [certificationToDelete, setCertificationToDelete] = useState(null);

    const handleSaveCertification = async (certificationData) => {
        try {
            let updatedCertifications = [...certifications];
            let newCertification = null;
    
            if (editingCertification) {
                const id = editingCertification.id;
                newCertification = await updateCurriculumVitaeCertification(id, certificationData); 
                updatedCertifications = updatedCertifications.map((certification) =>
                    certification.id === id ? newCertification.data : certification
                );
                toast.success('Certification updated successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
            } else {
                newCertification = await createCurriculumVitaeCertification(certificationData);
                updatedCertifications.push(newCertification.data);
                toast.success('Certification added successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
            }
    
            setCertifications(updatedCertifications);
            setCurriculumVitae((prevCv) => ({
                ...prevCv,
                curriculumVitaeCertifications: updatedCertifications,
            }));
    
            setEditingCertification(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
        }
    };
   
    const handleDeleteCertification = async () => {
        if (!certificationToDelete) return;
        try {
            await deleteCurriculumVitaeCertification(certificationToDelete);
            setCertifications((prevCertifications) => prevCertifications.filter((certification) => certification.id !== certificationToDelete));
            setCurriculumVitae((prevCv) => {
                const updatedCertifications = prevCv.curriculumVitaeCertifications.filter((certification) => certification.id !== certificationToDelete);
                return {
                    ...prevCv,
                    curriculumVitaeCertifications: updatedCertifications,
                };
            });
            toast.success('Certification deleted successfully!', getSuccesToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
            setCertificationToDelete(null);
        } catch (error) {
            toast.error('Something went wrong! Please try again.', getErrorUpdateToastPropsBy(COMPLETE_CURRICULUM_VITAE_CERTIFICATION_TOAST_MESSAGES));
        }
    };

    const handleEditCertification = (certification) => {
        const sanitizedCertification = {
            ...certification,
            expiryDate: certification.expiryDate?.startsWith('0001-01-01') ? '' : certification.expiryDate
        };
        setEditingCertification(sanitizedCertification);
    };

    const confirmDeleteCertification = (certificationId) => {
        setCertificationToDelete(certificationId);
        handleShowModal(CONFIRM_MODAL_ID);
    };

    return (
            <div>
                <h4 className="mb-4" style={{textDecoration: 'underline', textUnderlineOffset: '7px'}}>
                    Certifications
                </h4>

                <CertificationForm 
                    curriculumVitaeId={curriculumVitae.id} 
                    initialCertification={editingCertification} 
                    setEditingCertification={setEditingCertification} 
                    onSave={handleSaveCertification}/>
            
                <CertificationList certifications={certifications} onEdit={handleEditCertification} onDelete={confirmDeleteCertification}/>

                <ConfirmModal
                    id={CONFIRM_MODAL_ID}
                    title="Are you sure you want to delete this certification?"
                    message="This will permanently remove the selected certification from your profile. Do you wish to proceed?"
                    onConfirm={handleDeleteCertification}
                />
        </div>
    )
}

export default Certification;